/**
 * Was ein Klick auf den Listen-Knopf in der Aktionsspalte tut (#265).
 *
 * Bis #265 gab es hier eine Quick-Add-Abkuerzung: war genau eine Arbeitsliste
 * aktiv, fuegte der Klick den Parameter direkt hinzu, ohne den Dialog zu
 * oeffnen. Das erzeugte ein zweites Bedienelement fuer dieselbe Liste (neben
 * der A/B-Spalte in ParameterRow), das nur hinzufuegen, aber nicht entfernen
 * konnte -- ein Klick, der ins Leere ging, wenn man damit entfernen wollte.
 *
 * Seit #265 oeffnet der Knopf immer den Dialog, unabhaengig davon, wie viele
 * Arbeitslisten gerade aktiv sind oder ob es ueberhaupt Arbeitslisten gibt --
 * die A/B-Spalte bleibt der Umschalter fuer die aktive Liste (AK4).
 *
 * Korrektur (Review Runde 2): der Dialog "beherrscht" NICHT add/remove fuer
 * alle Listen. `useWorkingLists.handleToggleParameterInList` entfernt nur aus
 * **privaten** Listen; bei oeffentlichen Listen kann er ausschliesslich
 * hinzufuegen (mit Genehmigungs-Workflow) -- `WorkingListDialog` deaktiviert
 * dort bewusst den Klick, wenn der Parameter schon drin ist. Das ist eine
 * bestehende Einschraenkung des Dialogs, nicht Teil von #265, und aendert an
 * AK4 nichts: die A/B-Spalte ruft `handleAddToList`/`handleRemoveFromList`
 * direkt auf, unabhaengig von privat/oeffentlich, und ist damit -- unabhaengig
 * vom Dialog -- bereits der vollstaendige Umschalter fuer die aktive Liste.
 * Siehe DataCatalog.test.js, "entfernt aus einer aktiven OEFFENTLICHEN Liste".
 *
 * Korrektur (Review Runde 3, Blocker 1): der vorherige Kommentar hier
 * behauptete, listDialogHandlers.test.js pruefe "die Entscheidung selbst".
 * Das war falsch -- diese Funktion nimmt weder `activeWorkingList` noch
 * `parameterLists` noch `addToList` entgegen, sie kann also, egal was man ihr
 * uebergibt, gar keine Quick-Add-Entscheidung mehr treffen. Ein Test, der ihr
 * einen `addToList`-Spion mitgibt und danach prueft, dass er nicht aufgerufen
 * wurde, prueft nichts: die Funktion liest den Schluessel nie, der Spion kann
 * gar nicht aufgerufen werden. Diese Funktion ist nur noch Zustands-Kleber
 * (zwei Setter, unbedingt); ihr eigener Unit-Test kann daher nur genau das
 * belegen, nicht mehr.
 *
 * Die eigentliche Zusicherung -- niemand baut die Abkuerzung direkt in
 * `DataCatalog.js`s `handleOpenListDialog` wieder ein, an dieser Funktion
 * vorbei -- kann nur ein Test leisten, der den echten Knopf in der echten
 * Seite klickt und beobachtet, dass dabei keine Listen-API aufgerufen wird:
 * DataCatalog.test.js, fuer beide Knopf-Zustaende (Parameter schon in der
 * aktiven Liste / noch nicht drin -- die alte Abkuerzung unterschied sich
 * genau darin).
 */
export function oeffneListenDialogFuerParameter(parameterId, { setSelectedParameterForList, setListDialogOpen }) {
  setSelectedParameterForList(parameterId);
  setListDialogOpen(true);
}
